import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "selected-car-placeholder placeholder-glow" }
const _hoisted_2 = { class: "elements placeholder-glow" }
const _hoisted_3 = {
  key: 0,
  class: "placeholder col-3"
}
const _hoisted_4 = {
  key: 1,
  class: "placeholder circle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showPlaceholder)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.showPlaceholder)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}